import { Injectable } from '@angular/core';
import { ActivitiesAggrigatorModel } from '@shared/model/activities-aggrigator-model';
import { ActivityVerbEnum } from '@shared/model/enum/activity-verb-enum';

@Injectable({
  providedIn: 'root'
})
export class GeneralNotifSterategy {
  public createText(activity: ActivitiesAggrigatorModel, receiver: string, isFireBaseContext: boolean): string {
    const actorName = isFireBaseContext ? activity?.actor?.fullName ?? '' : '';

    switch (activity?.verb) {
      case ActivityVerbEnum.Posted:
        return `${actorName} پست منتشر کرد.`;

      default:
        return '';
    }
  }
}
